module.exports = "/_next/static/images/Frame@2x-bffb45f247a5fd5f742a95fc93b31cc7.png";